'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = protocol;

var _makeSymbol2 = require('./internal/_makeSymbol');

var _makeSymbol3 = _interopRequireDefault(_makeSymbol2);

var _setArity2 = require('./internal/_setArity');

var _setArity3 = _interopRequireDefault(_setArity2);

var _uniqueId = require('./uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DISPATCH_TYPE = (0, _makeSymbol3.default)('protocolType');

function getValueKey(id, value) {
  switch (value) {
    case null:
    case undefined:
      return '' + value;
    default:
      return value.constructor[id] || value[id];
  }
}

function makeKey(id, Type) {
  switch (Type) {
    case null:
      return 'null';
    case undefined:
      return 'undefined';
    default:
      return Type[id] || (0, _uniqueId2.default)();
  }
}

function makeKeyInherited(id, Type) {
  switch (Type) {
    case null:
      return 'null';
    case undefined:
      return 'undefined';
    default:
      return Type.prototype.hasOwnProperty(id) ? Type.prototype[id] : (0, _uniqueId2.default)();
  }
}

function setKey(subject, id, key) {
  Object.defineProperty(subject, id, {
    configurable: false,
    enumerable: false,
    value: key,
    writable: true
  });
  return subject;
}

function protocol(_ref) {
  var args = _ref.args,
      name = _ref.name,
      fallback = _ref.fallback;

  var dispatchValueIndex = args.indexOf(DISPATCH_TYPE);
  var id = (0, _makeSymbol3.default)('__p_' + name);
  var implementations = {};

  var dispatch = (0, _setArity3.default)(args.length, function () {
    for (var _len = arguments.length, argValues = Array(_len), _key = 0; _key < _len; _key++) {
      argValues[_key] = arguments[_key];
    }

    var value = argValues[dispatchValueIndex];
    var key = getValueKey(id, value);
    var implementation = key && implementations[key] || fallback;
    if (!implementation) {
      throw new Error(name + ': not implemented for type `' + value + '`');
    }
    return implementation.apply(undefined, argValues);
  });

  dispatch.implement = function (Type, implementation) {
    var key = makeKey(id, Type);
    if (Type !== undefined && Type !== null && !Type[id]) {
      setKey(Type, id, key);
    }
    implementations[key] = implementation;
    return implementation;
  };

  dispatch.implementInherited = function (Type, implementation) {
    var key = makeKeyInherited(id, Type);
    if (Type !== undefined && Type !== null && !Type.prototype.hasOwnProperty(id)) {
      setKey(Type.prototype, id, key);
    }
    implementations[key] = implementation;
    return implementation;
  };

  return dispatch;
}

protocol.TYPE = DISPATCH_TYPE;
module.exports = exports['default'];